module.exports = ".programWrapper {\n  position: relative; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/allPanels/panels/program/program.component.scss
// module id = ./src/app/allPanels/panels/program/program.component.scss
// module chunks = main